import { apiClient } from "@base/api/client";
import type { AutoPayInfo, UpdateAutoPayRequest } from "@features/membership/model/types";

/**
 * GET /82office/payment/api/auto-pay
 * 멤버십 자동 결제 정보 조회 (Subscription이 없는 회사는 next_payment_date: null)
 */
export async function fetchAutoPay(): Promise<AutoPayInfo> {
  const { data } = await apiClient.get<AutoPayInfo>("/82office/payment/api/auto-pay");
  return data;
}

/**
 * PATCH /82office/payment/api/auto-pay
 * 자동 결제 수단으로 등록 (payment_item: MEMBERSHIP 고정)
 * Error: INVALID_REQUEST_DATA - Invalid request data.
 */
export async function updateAutoPay(paymentMethodId: string): Promise<void> {
  const body: UpdateAutoPayRequest = {
    payment_item: "MEMBERSHIP",
    payment_method: paymentMethodId,
  };
  await apiClient.patch("/82office/payment/api/auto-pay", body);
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
 * import { fetchAutoPay, updateAutoPay } from "@features/membership/api/autoPay";
 *
 * const queryClient = useQueryClient();
 *
 * const { data } = useQuery({
 *   queryKey: ["autoPay"],
 *   queryFn: fetchAutoPay,
 * });
 *
 * const updateMutation = useMutation({
 *   mutationFn: updateAutoPay,
 *   onSuccess: () => {
 *     queryClient.invalidateQueries({ queryKey: ["autoPay"] });
 *   },
 * });
 * updateMutation.mutate("pm_xxx");
 */
